import { takeEvery, put } from 'redux-saga/effects';
import { actionTypes } from 'redux-form/immutable';
import { SET_CART_FACEPLATE_ORDINAL } from '../cart/cartModule';

const calculateGroupOrdinal = categoryValue => categoryValue;

function* handleReduxFormChange(action) {
    const payload = action;
    if (action.meta && action.meta.field === 'newForm.selectedGroupOrdinal') {
        const newGroupOrdinal = calculateGroupOrdinal(payload.payload);
        yield put({ type: SET_CART_FACEPLATE_ORDINAL, payload: newGroupOrdinal });
    }
}

export function* editCartReduxFormChange() {
    yield takeEvery(actionTypes.CHANGE, handleReduxFormChange);
}
